import {Outlet, useLocation} from 'react-router';
import {motion} from 'framer-motion';

function LabFullLayout() {
  const {pathname} = useLocation();
  return (
    <>
      <div className="container mb-5 pb-5">
        <motion.div
          key={pathname}
          initial={{opacity: 0, x: '100%'}}
          animate={{opacity: 1, x: 0}}
          exit={{opacity: 0, x: '-100%'}}
          transition={{duration: 0.2}}
          className="w-100 vh-100 p-3"
        >
          <Outlet />
        </motion.div>
      </div>
    </>
  );
}

export default LabFullLayout;
